import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Notification } from '../models/notification.model';

export interface BillingStatusChangedEvent {
  facilityId: string;
  type: 'corporate_payer_removed' | 'facility_reinstated';
}

@Injectable({ providedIn: 'root' })
export class NotificationsManagerService {
  markAsRead = new Subject<string>();
  shiftNeedSelected$ = new Subject<Notification>();
  billingStatusChanged$ = new Subject<BillingStatusChangedEvent>();
}
